import { profilePageMessages } from 'azshared';
import { PersonaTipoEnum } from 'azshared/build/main/lib/api/generated';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import './menu-header.scss';

export const AppMenuHeader = (props: {
  name: string;
  surname: string;
  onProfileIconPress: () => void;
  businessName: string;
  userType: string;
  // not clickable, e.g. for the users that cannot access the profile
  disabled?: boolean;
}) => {
  const { formatMessage } = useIntl();

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        props.onProfileIconPress?.();
      }
    },
    [props]
  );

  return (
    <div
      className={`app-menu-header${props.disabled ? ' disabled' : ''}`}
      onClick={props.disabled ? undefined : props.onProfileIconPress}
      onKeyDown={props.disabled ? undefined : handleKeyDown}
      tabIndex={props.disabled ? undefined : 0}>
      <svg className='app-menu-header-avatar' />
      <div className='app-menu-header-description'>
        <span className='app-menu-header-name'>
          {props.userType === PersonaTipoEnum.Pf && `${props.name} ${props.surname}`}
          {props.userType === PersonaTipoEnum.Pg && props.businessName}
        </span>
        {props.userType === PersonaTipoEnum.Pg && <span className='app-menu-header-name-FA'>{`${props.name} ${props.surname}`}</span>}
        <div className='app-menu-header-my-azimut'>{formatMessage(profilePageMessages.disclaimerMyAzimut)}</div>
      </div>
    </div>
  );
};
